type QueryStatus = 'loading' | 'failed' | 'fulfilled';
const getQueryStatus = (query: { isLoading: boolean; isError: boolean }): QueryStatus => {
  if (query.isLoading) return 'loading';
  if (query.isError) return 'failed';
  return 'fulfilled';
};
export default getQueryStatus;
